import { render, staticRenderFns } from "./VouchersReload.vue?vue&type=template&id=2a3fc52e&"
import script from "./VouchersReload.vue?vue&type=script&lang=js&"
export * from "./VouchersReload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgch/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a3fc52e')) {
      api.createRecord('2a3fc52e', component.options)
    } else {
      api.reload('2a3fc52e', component.options)
    }
    module.hot.accept("./VouchersReload.vue?vue&type=template&id=2a3fc52e&", function () {
      api.rerender('2a3fc52e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwg/js/components/VouchersReload.vue"
export default component.exports